import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useUserInfoStore } from '@/store/use-user-info-store';

const locales: Record<string, string> = {
  et: 'et_EE',
  ru: 'ru_RU',
  en: 'en_US',
};

export type Locale = keyof typeof locales;

function updateLangParam(lang: string) {
  const url = new URL(window.location.href);
  url.searchParams.set('lang', lang);

  window.history.pushState(null, '', url);
}

const getLocaleFromURL = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('lang');
};

export function useLocale() {
  const { i18n } = useTranslation();
  const { locale, setLocale } = useUserInfoStore();

  useEffect(() => {
    const urlLocale = getLocaleFromURL();
    const initialLocale = urlLocale || locale;

    if (locales[initialLocale]) {
      i18n.changeLanguage(initialLocale);
      setLocale(initialLocale);
      updateLangParam(initialLocale);
    }
  }, [i18n, locale, setLocale]);

  const handleLocaleChange = (locale: string) => {
    i18n.changeLanguage(locale);
    setLocale(locale);
    updateLangParam(locale);
  };

  return {
    locales,
    availableLocales: Object.keys(locales),
    handleLocaleChange,
    currentLocale: locale,
  };
}
